import { requestService } from '../';

export const validateSetPasswordToken = async (token: string) => {
	const { data } = await requestService.get(`/auth/authorization/setPassword?token=${token}`);
	return data;
};
